/* eslint-disable filenames/match-exported */
import React from 'react';
import { createRoot } from 'react-dom/client';
import DirectoryPageWrapper from '../../src/js/directory/DirectoryPageWrapper.jsx';
import '../../src/styles/exhibitor-directory.less';
import '../../src/styles/survey-banner.less';
import { authController } from '@reedexpo/authorization-component-ui';
import { HashRouter } from 'react-router-dom';
import Utils from '../../src/js/common/Utils';

export default DirectoryPageWrapper;

function renderComponent(props, testVariants, elementId) {
  const container = document.getElementById(elementId);
  const root = createRoot(container);
  root.render(<HashRouter><DirectoryPageWrapper {...props} testVariants={testVariants} /></HashRouter>);
}

if (global.window && global.window.document) {
  const testVariants = window.testVariants;
  const { props, elementId } = window.reactSettings;

  const eveId = window.reactSettings.props.context.eventEditionId;
  const showPlanningIds = JSON.parse(Utils.getFromLocalStorage('showPlanningIds'));
  if (showPlanningIds && showPlanningIds !== null) {
    props.showPlanId = showPlanningIds[eveId];
  }

  const authSettings = window.authSettings;
  if (authSettings && authSettings.usePkce) {
    authController.initialize(authSettings);
    if (authSettings.forceLogin) {
      authController.login(window.location.href).then((canRender) => {
        if (canRender) {
          renderComponent(props, testVariants, elementId);
        }
      });
    } else {
      renderComponent(props, testVariants, elementId);
    }
  } else {
    renderComponent(props, testVariants, elementId);
  }
}
